module.exports = __webpack_public_path__ + "img/msg4.76172182.png";